/**
 * driver.js 0.9.x — 兼容 webpack3（无 ES module / spread 语法）
 */
import DriverModule from "driver.js";
import "driver.js/dist/driver.min.css";

var Driver =
  DriverModule && DriverModule.default
    ? DriverModule.default
    : DriverModule;
import {
  FEATURE_GUIDE_STEPS,
  GUIDE_IDS,
  GUIDE_STORAGE_PREFIX,
} from "@/config/featureGuides";

let activeDriver = null;
let mobileClampHandler = null;

function isElementVisible(el) {
  if (!el || !el.getBoundingClientRect) return false;
  const style = window.getComputedStyle(el);
  if (
    style.display === "none" ||
    style.visibility === "hidden" ||
    Number(style.opacity) === 0
  ) {
    return false;
  }
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

export function queryGuideElement(anchor) {
  if (!anchor || typeof document === "undefined") return null;
  const nodes = document.querySelectorAll(
    '[data-ebk-guide="' + anchor + '"]'
  );
  for (let i = 0; i < nodes.length; i++) {
    const el = nodes[i];
    if (isElementVisible(el)) return el;
  }
  return null;
}

function ensureDummyElement() {
  var id = "driver-dummy-element";
  var el = document.getElementById(id);
  if (!el) {
    el = document.createElement("div");
    el.id = id;
    el.style.cssText =
      "position:fixed;top:50%;left:50%;width:0;height:0;pointer-events:none;opacity:0;";
    document.body.appendChild(el);
  }
  return el;
}

function mapPopoverPosition(side, hasElement) {
  if (side === "over" || !hasElement) return "mid-center";
  if (
    side === "top" ||
    side === "bottom" ||
    side === "left" ||
    side === "right"
  ) {
    return side;
  }
  return "bottom";
}

function isDriverLastStep(inst) {
  if (!inst || !inst.steps || !inst.steps.length) return false;
  var idx =
    typeof inst.currentStep === "number" ? inst.currentStep : 0;
  return idx >= inst.steps.length - 1;
}

function isViewportMobile() {
  return (
    (window.innerWidth || document.documentElement.clientWidth || 1200) <=
    992
  );
}

function unbindMobileGuideClamp() {
  if (!mobileClampHandler) return;
  window.removeEventListener("resize", mobileClampHandler);
  window.removeEventListener("orientationchange", mobileClampHandler);
  mobileClampHandler = null;
}

/** 多次校正，覆盖 driver 0.9 的 absolute + 文档坐标 */
function scheduleClampDriverPopover(anchorEl) {
  clampDriverPopoverToViewport(anchorEl);
  [50, 150, 380, 600].forEach(function (ms) {
    setTimeout(function () {
      clampDriverPopoverToViewport(anchorEl);
    }, ms);
  });
  if (!isViewportMobile()) return;
  unbindMobileGuideClamp();
  mobileClampHandler = function () {
    clampDriverPopoverToViewport(anchorEl);
  };
  window.addEventListener("resize", mobileClampHandler);
  window.addEventListener("orientationchange", mobileClampHandler);
}

/** 将 0.9 弹层限制在视口内；桌面端避免把弹层整体拽到左下角 */
function clampDriverPopoverToViewport(anchorEl) {
  var pop = document.getElementById("driver-popover-item");
  if (!pop || pop.style.display === "none") return;

  var pad = 12;
  var vw =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    1200;
  var vh =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    800;
  var isMobile = isViewportMobile();
  var rect = pop.getBoundingClientRect();
  var curLeft = parseFloat(pop.style.left);
  var curTop = parseFloat(pop.style.top);
  if (isNaN(curLeft)) curLeft = rect.left;
  if (isNaN(curTop)) curTop = rect.top;

  if (isMobile) {
    /* 宽高由 feature-guide.css 居中卡片；JS 只校正垂直位置与滚动 */
    var padH = 20;
    var padBottom = 16;

    pop.style.position = "fixed";
    pop.style.minWidth = "0";
    pop.style.right = "auto";
    pop.style.margin = "0";
    pop.style.boxSizing = "border-box";
    pop.style.left = "";
    pop.style.width = "";
    pop.style.maxWidth = "";
    pop.style.transform = "";
    pop.style.maxHeight = Math.round(vh * 0.52) + "px";
    pop.style.overflowY = "auto";
    pop.style.webkitOverflowScrolling = "touch";

    var pinBottom = false;
    var topM = padH;
    if (anchorEl && anchorEl.getBoundingClientRect) {
      var arM = anchorEl.getBoundingClientRect();
      topM = arM.bottom + padH;
      if (arM.top < vh * 0.42 || topM + rect.height > vh - padBottom) {
        pinBottom = true;
      }
    } else if (rect.height > vh * 0.55) {
      pinBottom = true;
    }

    if (pinBottom) {
      pop.style.top = "auto";
      pop.style.bottom = padBottom + "px";
    } else {
      pop.style.bottom = "auto";
      rect = pop.getBoundingClientRect();
      if (topM + rect.height > vh - padBottom) {
        topM = Math.max(padH, vh - rect.height - padBottom);
      }
      pop.style.top = Math.round(topM) + "px";
    }
    return;
  }

  /* 桌面端：优先贴在锚点右侧，仅做边界修正 */
  var newLeft = curLeft;
  var newTop = curTop;

  if (anchorEl && anchorEl.getBoundingClientRect) {
    var ar = anchorEl.getBoundingClientRect();
    newLeft = ar.right + pad;
    newTop = Math.max(pad, ar.top);
    if (newTop + rect.height > vh - pad) {
      newTop = Math.max(pad, vh - rect.height - pad);
    }
  }

  if (newLeft + rect.width > vw - pad) {
    newLeft = vw - rect.width - pad;
  }
  if (newLeft < pad) newLeft = pad;
  if (newTop < pad) newTop = pad;
  if (newTop + rect.height > vh - pad) {
    newTop = Math.max(pad, vh - rect.height - pad);
  }

  pop.style.left = Math.round(newLeft) + "px";
  pop.style.top = Math.round(newTop) + "px";
}

function attachNeverBtn(driverInst, guideId, supplierCode) {
  setTimeout(function () {
    var popover = document.getElementById("driver-popover-item");
    if (!popover || popover.querySelector(".ebk-guide-never-btn")) return;
    var footer =
      popover.querySelector(".driver-popover-footer") ||
      popover.querySelector(".driver-popover-tip") ||
      popover;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ebk-guide-never-btn";
    btn.textContent = "不再提示";
    btn.addEventListener("click", function () {
      markGuideDone(guideId, supplierCode);
      try {
        driverInst.reset();
      } catch (e) {
        /* ignore */
      }
    });
    footer.insertBefore(btn, footer.firstChild);
    scheduleClampDriverPopover(null);
  }, 80);
}

export function getSupplierCodeFromContext(ctx) {
  try {
    if (ctx && ctx.userInfo && ctx.userInfo.code) {
      return String(ctx.userInfo.code).trim();
    }
    const raw = ctx && ctx.getToken ? ctx.getToken("userInfo") : null;
    if (raw) {
      const u = JSON.parse(raw);
      if (u && u.code) return String(u.code).trim();
    }
  } catch (e) {
    /* ignore */
  }
  return "anonymous";
}

export function getStorageKey(guideId, supplierCode) {
  return (
    GUIDE_STORAGE_PREFIX +
    "::" +
    guideId +
    "::" +
    (supplierCode || "anonymous")
  );
}

export function isGuideDone(guideId, supplierCode) {
  try {
    return (
      localStorage.getItem(getStorageKey(guideId, supplierCode)) === "1"
    );
  } catch (e) {
    return false;
  }
}

export function markGuideDone(guideId, supplierCode) {
  try {
    localStorage.setItem(getStorageKey(guideId, supplierCode), "1");
  } catch (e) {
    /* ignore */
  }
}

export function shouldAutoStart(guideId, supplierCode) {
  return !isGuideDone(guideId, supplierCode);
}

export function destroyActiveGuide() {
  unbindMobileGuideClamp();
  if (activeDriver) {
    try {
      activeDriver.reset();
    } catch (e) {
      /* ignore */
    }
  }
  activeDriver = null;
}

export function startFeatureGuide(guideId, options) {
  options = options || {};
  const defs = FEATURE_GUIDE_STEPS[guideId];
  if (!defs || !defs.length) {
    return null;
  }

  const supplierCode = getSupplierCodeFromContext(options.ctx);
  const manual = !!options.manual;
  const canMaintain = options.canMaintain !== false;
  const embedMode = !!options.embedMode;

  const steps = [];
  defs.forEach(function (def) {
    if (def.requireMaintain && !canMaintain) return;
    if (def.skipInEmbed && embedMode) return;

    const optional = def.optional !== false;
    const el = def.anchor ? queryGuideElement(def.anchor) : null;
    if (def.anchor && !el && optional) return;
    if (def.anchor && !el && !optional) return;

    const target = el || ensureDummyElement();
    var popPosition = mapPopoverPosition(def.side, !!el);
    if (isViewportMobile() && el) {
      popPosition = def.mobilePosition || "bottom-center";
    }
    steps.push({
      element: target,
      popover: {
        title: def.title,
        description: def.description,
        position: popPosition,
        className: "driver-popover ebk-driver-popover",
      },
    });
  });

  if (!steps.length) {
    if (options.ctx && options.ctx.$message) {
      options.ctx.$message.info("当前页面暂无可展示的引导步骤");
    }
    return null;
  }

  destroyActiveGuide();

  var finished = false;
  function finishGuide() {
    if (finished) return;
    finished = true;
    unbindMobileGuideClamp();
    try {
      document.body.classList.remove("driver-active");
    } catch (e) {
      /* ignore */
    }
    activeDriver = null;
    if (!manual) {
      markGuideDone(guideId, supplierCode);
    }
    if (typeof options.onComplete === "function") {
      options.onComplete();
    }
  }

  if (typeof Driver !== "function") {
    console.error("[ebk-guide] driver.js 未正确加载，请确认已安装 driver.js@0.9.8");
    if (options.ctx && options.ctx.$message) {
      options.ctx.$message.error("引导组件加载失败，请联系管理员");
    }
    return null;
  }

  try {
    document.body.classList.add("driver-active");
  } catch (e) {
    /* ignore */
  }

  const driverInstance = new Driver({
    /* 移动端若 animate:false，driver 0.9 会删掉 #driver-page-overlay，背景不会变暗 */
    animate: true,
    opacity: 0.65,
    padding: 8,
    allowClose: true,
    showButtons: true,
    showProgress: true,
    doneBtnText: manual ? "完成" : "知道了",
    closeBtnText: "关闭",
    nextBtnText: "下一步",
    prevBtnText: "上一步",
    onReset: function () {
      finishGuide();
    },
    onHighlighted: function (element) {
      var anchorNode =
        element && element.getNode ? element.getNode() : null;
      scheduleClampDriverPopover(anchorNode);
      if (!manual || !activeDriver) return;
      if (isDriverLastStep(activeDriver)) {
        attachNeverBtn(activeDriver, guideId, supplierCode);
      }
      if (manual && element && element.popover && element.popover.renderFooter) {
        try {
          element.popover.renderFooter();
          scheduleClampDriverPopover(anchorNode);
        } catch (e) {
          /* ignore */
        }
      }
    },
  });

  activeDriver = driverInstance;
  driverInstance.defineSteps(steps);
  driverInstance.start();
  return driverInstance;
}

var OVERVIEW_MESSAGE =
  "1. 在酒店列表找到目标酒店\n2. 进入房型页维护政策、房价与房态\n3. 在订单列表处理新订单\n4. 在结算列表发起结算并对账";

function openOverviewConfirm(ctx) {
  if (!ctx || !ctx.$confirm) {
    return Promise.resolve("skip");
  }
  return ctx
    .$confirm(OVERVIEW_MESSAGE, "欢迎使用 ebooking", {
      confirmButtonText: "开始引导",
      cancelButtonText: "跳过",
      type: "info",
      customClass: "ebk-guide-overview-box",
      closeOnClickModal: false,
    })
    .then(function () {
      return "start";
    })
    .catch(function () {
      return "skip";
    });
}

/** 首次自动引导用（已停用自动触发，保留供兼容） */
export function showOverviewIfNeeded(ctx) {
  const supplierCode = getSupplierCodeFromContext(ctx);
  if (!shouldAutoStart(GUIDE_IDS.overview, supplierCode)) {
    return Promise.resolve("done");
  }
  return openOverviewConfirm(ctx).then(function (r) {
    markGuideDone(GUIDE_IDS.overview, supplierCode);
    return r;
  });
}

/** 点击「新手指引」时先展示欢迎说明，再进入当前页步骤引导 */
export function showOverviewOnManual(ctx) {
  return openOverviewConfirm(ctx);
}

export { GUIDE_IDS, getGuideIdForRoute } from "@/config/featureGuides";



// WEBPACK FOOTER //
// ./src/utils/featureGuide.js